import React from "react";
import {
  Text,
  Box,
  UnorderedList,
  ListItem,
  useColorMode,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import PageLayout from "./PageLayout";

const TermsOfUse: React.FC = () => {
  const { colorMode } = useColorMode();
  const { t } = useTranslation();

  const textColor = colorMode === "light" ? "gray.700" : "gray.200";

  return (
    <PageLayout title={t("termsOfUse.title", "Terms of Use")}>
      <Box>
        <Text mb={4} color={textColor}>
          {t("termsOfUse.lastUpdated", "Last Updated: January 1, 2023")}
        </Text>

        <Text mb={4} color={textColor}>
          {t(
            "termsOfUse.introduction",
            "Welcome to QazBilim. By accessing or using our service, you agree to be bound by these Terms of Use. Please read these terms carefully before using our service."
          )}
        </Text>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("termsOfUse.userAccounts", "User Accounts")}
        </Text>

        <Text mb={4} color={textColor}>
          {t(
            "termsOfUse.accountResponsibility",
            "When you create an account with us, you must provide accurate and complete information. You are responsible for maintaining the security of your account and for all activities that occur under your account."
          )}
        </Text>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("termsOfUse.contentGuidelines", "Content Guidelines")}
        </Text>

        <UnorderedList mb={4} color={textColor}>
          <ListItem>
            {t(
              "termsOfUse.respectCopyright",
              "Respect copyright and intellectual property rights"
            )}
          </ListItem>
          <ListItem>
            {t(
              "termsOfUse.noIllegalContent",
              "Do not upload or share illegal, harmful, or offensive content"
            )}
          </ListItem>
          <ListItem>
            {t("termsOfUse.noMisuse", "Do not misuse or abuse the service")}
          </ListItem>
        </UnorderedList>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("termsOfUse.limitations", "Limitations of Liability")}
        </Text>

        <Text mb={4} color={textColor}>
          {t(
            "termsOfUse.liabilityInfo",
            "To the maximum extent permitted by law, QazBilim shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service."
          )}
        </Text>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("termsOfUse.termination", "Termination")}
        </Text>

        <Text mb={4} color={textColor}>
          {t(
            "termsOfUse.terminationInfo",
            "We may terminate or suspend your account immediately, without prior notice or liability, for any reason, including breach of these Terms of Use."
          )}
        </Text>

        <Text fontWeight="bold" mt={6} mb={2} color={textColor}>
          {t("termsOfUse.changes", "Changes to Terms")}
        </Text>

        <Text color={textColor}>
          {t(
            "termsOfUse.changesInfo",
            "We reserve the right to modify or replace these Terms of Use at any time. It is your responsibility to review these Terms periodically for changes."
          )}
        </Text>
      </Box>
    </PageLayout>
  );
};

export default TermsOfUse;
